import React from 'react';
import { InjectedFormProps } from 'redux-form';

import Button from 'ui/new/button';
import { BUTTON, COLOR } from 'ui/new/button/constants';
import { saveAndCloseModal, saveAndContinue } from '../../constants';

type InputProps = {
  handleSubmit: InjectedFormProps['handleSubmit'];
  cancelForm(): void;
  isFetching: boolean;
};

export default function Input({
  handleSubmit,
  cancelForm,
  isFetching,
}: InputProps) {
  return (
    <>
      <Button
        type={BUTTON.Light}
        onClick={cancelForm}
        loading={isFetching}
        disabled={isFetching}
      >
        Cancelar
      </Button>
      <Button
        type={BUTTON.Light}
        onClick={handleSubmit(saveAndContinue)}
        loading={isFetching}
        disabled={isFetching}
      >
        Salvar e Efetuar outra
      </Button>
      <Button
        type={BUTTON.Primary}
        onClick={handleSubmit(saveAndCloseModal)}
        loading={isFetching}
        color={COLOR.White}
        disabled={isFetching}
      >
        Salvar
      </Button>
    </>
  );
}
